<template>
  <div class="stepContainer step2">
    <step-header v-if="courseInfo" :title="courseInfo.courseName" />
    <div class="layout">
      <div class="title"></div>
      <div class="content">
        <h2>考生信息</h2>
        <table>
          <tr>
            <th>姓名：</th>
            <td><span>******</span></td>
            <td
              class="td-photo"
              rowspan="6"
            ><span /></td>
          </tr>
          <tr>
            <th>性别：</th>
            <td><span>******</span></td>
          </tr>
          <tr>
            <th>准考证号：</th>
            <td><span>******</span></td>
          </tr>
          <tr>
            <th>证件号码：</th>
            <td><span>******</span></td>
          </tr>
          <tr>
            <th>考试科目：</th>
            <td><span v-if="courseInfo">{{courseInfo.courseName}}</span></td>
          </tr>
          <tr>
            <th>考试时间：</th>
            <td><span v-if="courseInfo">{{ courseInfo.examTime }}</span></td>
          </tr>
          <tr>
            <td class="td-btns" colspan="3">
              <a
                href="javascript:void(0)"
                class="goNext"
                @click="goNext"
              >正 确</a>
              <a
                href="javascript:void(0)"
                class="goNext marleft30"
              >错 误</a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { StepHeader } from '@components/common'
import { mapGetters } from 'vuex'
import { setPageTitle, isEmptyObject, parseNumber, getCookie } from '@/utils'
import { moniexamQuestionTypes } from '@api'

export default {
  name: 'Step2',
  components: { StepHeader },
  computed: {
    ...mapGetters(['siteData'])
  },
  data() {
    return {
      courseInfo: null,
      siteCourseID: '',
      courseID: ''
    }
  },
  async mounted() {
    const { flag } = this.$route.params
    let _flag = flag === 'paidExam' ? '' : flag
    const { siteCourseID, courseID } = this.$route.query
    const { majorID } = this.$categoryInfo
    this.siteCourseID = parseNumber(siteCourseID)
    this.courseID = courseID

    if (isEmptyObject(this.siteData)) {
      let params = {
        flag: _flag,
        majorID: majorID,
        siteCourseID: this.siteCourseID
      }
      await this.$store
        .dispatch('getCurrentSiteInfo', params)
        .then(res => {
          this.courseInfo = res.currentCourse
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    } else {
      this.courseInfo = this.siteData.currentCourse
    }
    document.title = setPageTitle(this.courseInfo && this.courseInfo.siteCourseName)
  },
  methods: {
    goNext() {
      const { flag } = this.$route.query
      if (flag === 'ordinary') {
        this.$router.push({
          path: 'step3',
          query: {
            ...this.$route.query,
          }
        })
      } else {
        this.$router.push({
          path: 'step3',
          query: {
            siteCourseID: this.siteCourseID,
            courseID: this.courseID
          },
        })
      }
    }
  }
}
</script>
